module.exports = function (audioContext) {
  if (audioContext.state === 'suspended' &&
      typeof audioContext.resume === 'function') {
    audioContext.resume()
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/web-audio-player/lib/resume-context.js
// module id = 943
// module chunks = 1 2 3 4 5